/* ============================================================================
   ANIMOCO, V3
   Quatre comportements seulement, et rien qui existe déjà dans Horizon :
     1. synchronisation du choix d'offre avec le champ de variante natif ;
     2. barre d'achat mobile qui relaie le bouton natif d'ajout au panier ;
     3. apparition au défilement, désactivée sous prefers-reduced-motion ;
     4. retour visuel du bouton d'ajout au panier, purement cosmétique.
   L'ajout au panier, la mise à jour du panier et le paiement accéléré restent
   entièrement gérés par les composants natifs du thème. Aucun texte n'existe
   uniquement ici : les libellés sont écrits par Liquid dans le HTML.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marque la page comme animable. Sans cette classe, le CSS laisse tout
     visible : une panne de script ne peut pas vider la page. */
  if (!reduceMotion) {
    document.documentElement.classList.add('a-js');
  }

  /* -- 1. Choix de l'offre ------------------------------------------------ */
  function initOffers(root) {
    if (!root || root.dataset.aOffersReady === 'true') return;
    var variantInput = root.querySelector('input[ref="variantId"]');
    var inputs = root.querySelectorAll('[data-a-offer-input]');
    if (!inputs.length) return;

    function apply(input) {
      if (!input) return;
      if (variantInput && input.dataset.variantId) {
        variantInput.value = input.dataset.variantId;
      }
      var price = input.dataset.price || '';
      var label = input.dataset.label || '';
      document.querySelectorAll('[data-a-price]').forEach(function (node) {
        node.textContent = price;
      });
      document.querySelectorAll('[data-a-offer-label]').forEach(function (node) {
        node.textContent = label;
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) apply(input);
      });
      if (input.checked) apply(input);
    });

    root.dataset.aOffersReady = 'true';
  }

  /* -- 2. Barre d'achat mobile -------------------------------------------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-a-stickybar]');
    var anchor = document.querySelector('[data-a-buy-anchor]');
    if (!bar || !anchor) return;

    var trigger = bar.querySelector('[data-a-sticky-add]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var submit = anchor.querySelector('[data-a-submit]');
        if (submit) {
          submit.click();
        } else {
          anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px 0px -40% 0px', threshold: 0 }
    );
    observer.observe(anchor);

    /* Le bloc de conversion final propose déjà le même geste : on efface le
       rappel tant qu'il est à l'écran plutôt que d'empiler deux demandes. */
    var closing = document.querySelector('[data-a-closing]');
    if (closing) {
      var muteObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-muted', entry.isIntersecting);
          });
        },
        { threshold: 0.15 }
      );
      muteObserver.observe(closing);
    }
  }

  /* -- 4. Retour visuel de l'ajout au panier -------------------------------
     Strictement cosmétique. Le formulaire natif fait tout le travail : on se
     contente de basculer des états déjà présents dans le HTML, avec un retour
     automatique à l'état normal quoi qu'il arrive. */
  function initFeedback(root) {
    if (!root || root.dataset.aFeedbackReady === 'true') return;
    var form = root.querySelector('form[action*="/cart/add"]');
    var button = root.querySelector('[data-a-submit]');
    if (!form || !button) return;

    var timer = null;

    function reset() {
      button.classList.remove('is-busy', 'is-done');
    }

    function busy() {
      /* Le composant natif signale l'ajout dès la phase de capture de
         l'évènement submit, donc parfois avant ce gestionnaire. Si la
         confirmation est déjà passée, on ne la remplace pas par un état
         d'attente devenu faux. */
      if (button.classList.contains('is-done')) return;
      window.clearTimeout(timer);
      button.classList.add('is-busy');
      /* Filet de sécurité : si aucun évènement de panier ne remonte, le bouton
         ne reste jamais bloqué. */
      timer = window.setTimeout(reset, 6000);
    }

    button.addEventListener('click', busy);
    form.addEventListener('submit', busy);

    function confirmed() {
      window.clearTimeout(timer);
      button.classList.remove('is-busy');
      button.classList.add('is-done');
      timer = window.setTimeout(reset, 2600);
    }

    /* Évènements émis par le composant natif d'Horizon. Ils remontent par
       propagation depuis <product-form-component>. Si Shopify les renomme un
       jour, le bouton revient simplement à son état normal au bout de six
       secondes : rien ne casse. */
    ['shopify:cart:lines-update', 'cart:update', 'cart:add'].forEach(function (name) {
      root.addEventListener(name, confirmed);
    });

    ['shopify:cart:error', 'cart:error'].forEach(function (name) {
      root.addEventListener(name, reset);
    });

    root.dataset.aFeedbackReady = 'true';
  }

  /* -- 3. Apparition au défilement ---------------------------------------- */
  function revealAll() {
    document.querySelectorAll('.a-reveal').forEach(function (node) {
      node.classList.add('is-in');
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.a-reveal');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    /* Filet de sécurité : si l'observateur ne se déclenche jamais (navigateur
       sans rendu, onglet en arrière-plan, extension bloquante), tout est
       affiché au bout de 1,5 s. */
    window.setTimeout(revealAll, 1500);

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-a-buy-anchor]').forEach(function (node) {
      initOffers(node);
      initFeedback(node);
    });
    initStickyBar();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
